import { render } from "./ProsesPustaka.vue?vue&type=template&id=7b367936"
import script from "./ProsesPustaka.vue?vue&type=script&lang=js"
export * from "./ProsesPustaka.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__